module.exports = __webpack_public_path__ + "img/icon-check-circle.2c287ca3.svg";